import { render, staticRenderFns } from "./csOptions.vue?vue&type=template&id=22fe97de&scoped=true&"
import script from "./csOptions.vue?vue&type=script&lang=js&"
export * from "./csOptions.vue?vue&type=script&lang=js&"
import style0 from "./csOptions.vue?vue&type=style&index=0&id=22fe97de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe97de",
  null
  
)

export default component.exports